import { For } from 'solid-js';
import { radioStore } from '~/stores/radioStore';

export function RadioStationSelector() {
  return (
    <fieldset class="radio__stations" aria-label="Выбор радиостанции">
      <legend class="sr-only">Радиостанция</legend>
      <For each={radioStore.stations}>
        {(s) => {
          const isActive = () => radioStore.stationId() === s.id;
          return (
            <label
              class="radio__station"
              classList={{ 'radio__station--active': isActive() }}
            >
              <input
                type="radio"
                name="concept13-radio-station"
                value={s.id}
                checked={isActive()}
                onChange={() => radioStore.selectStation(s.id)}
                aria-checked={isActive()}
              />
              <span class="radio__station-radio" aria-hidden="true">
                <span />
              </span>
              <span class="radio__station-text">
                <span class="radio__station-name">{s.name}</span>
                <span class="radio__station-sub">{s.subtitle}</span>
              </span>
            </label>
          );
        }}
      </For>
    </fieldset>
  );
}
